import type { ReactNode } from 'react';
import { Card } from '../Card';
import { alert } from '../../../styled-system/recipes/alert';

type AlertType = 'info' | 'warning' | 'success';

type AlertProps = { children: ReactNode; type: AlertType };

export function Alert({ children, type }: AlertProps) {
  return <Card className={alert({ type })}>{children}</Card>;
}
